/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalRelatorioAliases {
  DECK = 'deck',
  FIELD_0 = 'field-0',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  IMAGE_0 = 'image-0',
  LAYOUT_0 = 'layout-0',
  LOADER_0 = 'loader-0',
  PANEL_0 = 'panel-0',
  PANEL_LOADER = 'panel-loader',
  PANEL_RELATORIO = 'panel-relatorio',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { ModalRelatorioAliases };
